module.exports = __webpack_public_path__ + "img/咖啡机.0538bd1a.png";